
import { RrPerson } from '@/commons/types'
import { applicantStore, userStore } from '@/store'
import { Component, Vue } from 'vue-property-decorator'
import ParentInfo from '@/commons/components/summary/content/ParentInfo.vue'
import {
    ADULT_AGE,
    ApplicantApplierRelationType
} from '@/commons/constants/application'
import { CarePerson } from '@/commons/types/care'

@Component({
    components: {
        ParentInfo
    }
})
export default class ParentsWrapper extends Vue {
    carePersons: Array<CarePerson> | null = []

    get father (): RrPerson | null {
        return applicantStore.father
    }

    get mother (): RrPerson | null {
        return applicantStore.mother
    }

    fetchCarePersons () : void {
        this.carePersons = this.rrPersonsToCarePersons(this.parentsAndRepresentatives())
    }

    get applyingForChild (): boolean {
        return applicantStore.applicantAge !== null && applicantStore.applicantAge < ADULT_AGE &&
            applicantStore.personCode !== userStore.personCode
    }

    parentsAndRepresentatives (): Array<RrPerson> {
        const caregivers = applicantStore.rrInfo?.careGivers
        const guardians = applicantStore.rrInfo?.guardians
        let guardiansAndCaregivers = new Array<RrPerson>()

        if (Array.isArray(caregivers)) {
            guardiansAndCaregivers = caregivers
        }
        if (Array.isArray(guardians)) {
            for (const guardian of guardians) {
                guardiansAndCaregivers.push(guardian)
            }
        }
        return guardiansAndCaregivers
    }

    rrPersonsToCarePersons (carePersonInfo: Array<RrPerson>): Array<CarePerson> {
        const fatherCode = this.father?.personCode
        const motherCode = this.mother?.personCode
        const carePersons = new Array<CarePerson>()
        const usedPersonCodes = new Array<string>()

        for (const carePerson of carePersonInfo) {
            const applicantApplierRelation = carePerson.personCode === fatherCode || carePerson.personCode === motherCode
            const fullName = carePerson.firstName + ' ' + carePerson.lastName
            const person = new CarePerson(fullName, carePerson.personCode, applicantApplierRelation ? ApplicantApplierRelationType.CHILD : ApplicantApplierRelationType.WARD)
            if (!usedPersonCodes.includes(person.personCode)) {
                carePersons.push(person)
                usedPersonCodes.push(person.personCode)
            }
        }
        return carePersons
    }

    mounted (): void {
        this.fetchCarePersons()
    }
}
